import { BaseExporter } from '../base/BaseExporterMapping.js';
import NumberRounding from '../../../../../utils/numberRounding.js';

export default class NorwegianExporter extends BaseExporter {

    formatSpotLengths(spotLengths = []) {
        return [...spotLengths || []]
            .sort((a, b) => (typeof a === 'object' ? a.spotLength - b.spotLength : a - b))
            .map(item => typeof item === 'object' ? item.spotLength : item)
            .join(', ');
    }

    export() {
        const baseData = this.getBaseData();
        const metrics = this.getCampaignMetrics();
        const deliveredPlays = this.deliveryData?.playData || {};

        const exportData = {
            ...baseData,
            'Estimated VAC/VI': metrics.estimatedEAVAC,
            'Delivered VAC/VI': metrics.deliveredEAVAC,
            'VAC/VI over delivery': Math.max(0, metrics.deliveredEAVAC - metrics.estimatedEAVAC),
            'Delivered Alternative VAC/VI': this.delivered.totalAlternateVAC || 0,
            'Estimated SOV': NumberRounding.round(this.orderline.targetSoV * 100.0, 2) || 0,
            'Delivered SOV': NumberRounding.round(this.delivered.soV * 100.0, 2) || 0,            
            'Estimated Panels': metrics.estimatedPanels,            
            'Delivered Panels': metrics.deliveredPanels,
            'Estimated Plays': metrics.estimatedPlays,
            'Delivered Plays': metrics.deliveredPlays,
            'Plays over delivery': Math.max(0, metrics.deliveredPlays - metrics.estimatedPlays),
            'Estimated Spot length': this.formatSpotLengths(deliveredPlays.aidaSpotLengths),
            'Delivered Spot length': this.formatSpotLengths(deliveredPlays.spotlengths),
            'Delivered Reach %': NumberRounding.round(this.deliveryData.orderLineDataInformation.idsReachPercent * 100.0, 2) || 0,
            'Delivered Reach': this.deliveryData.orderLineDataInformation.idsReach || 0,
            'Delivered Frequency': this.deliveryData.orderLineDataInformation.idsAverageFrequency || 0
        };

        return this.filterByPromiseType(exportData, baseData);
    }
}